var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10970_4055",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10970_4055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5925 38.319C8.05645 37.214 5.41345 35.2807 3.66345 32.519C1.91345 29.7577 1.03845 26.918 1.03845 24C1.03845 21.082 1.91345 18.2423 3.66345 15.481C5.41345 12.7193 8.05645 10.786 11.5925 9.681V12.05C9.16412 12.891 7.17629 14.4057 5.62895 16.594C4.08129 18.7827 3.30745 21.2513 3.30745 24C3.30745 26.7487 4.08129 29.209 5.62895 31.381C7.17629 33.5527 9.16412 35.0757 11.5925 35.95V38.319ZM28.0385 39C23.9281 39 20.4006 37.5275 17.456 34.5825C14.511 31.6378 13.0385 28.1103 13.0385 24C13.0385 19.8897 14.511 16.3622 17.456 13.4175C20.4006 10.4725 23.9281 9 28.0385 9C29.7281 9 31.4236 9.2975 33.125 9.8925C34.8263 10.4872 36.3551 11.4 37.7115 12.631L36.1925 14.2C35.0515 13.2463 33.77 12.5195 32.348 12.0195C30.9263 11.5195 29.4898 11.2695 28.0385 11.2695C24.5358 11.2695 21.5383 12.5155 19.046 15.0075C16.5536 17.4998 15.3075 20.4973 15.3075 24C15.3075 27.5027 16.5536 30.5002 19.046 32.9925C21.5383 35.4845 24.5358 36.7305 28.0385 36.7305C29.4898 36.7305 30.9263 36.4857 32.348 35.996C33.77 35.5063 35.0515 34.791 36.1925 33.85L37.7115 35.369C36.3551 36.6 34.8263 37.5128 33.125 38.1075C31.4236 38.7025 29.7281 39 28.0385 39ZM39.9075 30.973L38.277 29.3425L42.677 24.9425H26.2655V22.896H42.677L38.277 18.5155L39.9075 16.8655L46.9615 23.919L39.9075 30.973Z",
    fill: "#1C1B1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoney);
export default __webpack_public_path__ + "static/media/send_money.ed6c0e0ac34bed0c69e9ea52b53022ee.svg";
export { ForwardRef as ReactComponent };